import React, { useEffect, useState } from "react";

import { useHistory } from "react-router";

import {
  setAuthenticated,
  setToken,
  setUser,
} from "../../providers/local-storage";

import validate from "./form-validate";

import api from "../../providers/api";
import { danger } from "../../components/show-notification";
import { useGlobalContext } from "../../providers/context";

const Login = () => {
  const history = useHistory();

  const { setStateGlobal } = useGlobalContext();

  const [state, setState] = useState({ email: "", senha: "" });

  useEffect(() => {
    document.getElementById("tag-body").classList.add("gray-bg");

    let validation = window.$("#form-login").validate(validate);

    return () => {
      document.getElementById("tag-body").classList.remove("gray-bg");
      validation.destroy();
    };
  }, []);

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-login").valid()) {
      return;
    }

    try {
      const requisicao = await api.post("/autenticacao", state);
console.log(requisicao);

      const { data } = requisicao;
console.log(data);

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setToken(data.data.token.token);

      let usuario = {
        nome: data.data.usuario.nome,
        email: data.data.usuario.email,
      };

      setStateGlobal({ usuario: usuario });

      setUser(usuario);
      setAuthenticated(true);
      history.push("/");
    } catch (error) {
      console.log(error);
      danger("Erro ao fazer login. Por favor, verifique!");
    }
  };

  return (
    <>
      <div
        className="text-center animated fadeInDown"
        style={{ paddingTop: "50px" }}
      >
        <img alt="" src="https://ibraflex.com/wp-content/uploads/2025/07/logo-ibraflex.png" />
      </div>
      <div
        className="middle-box text-center loginscreen animated fadeInDown"
        style={{ paddingTop: "50px" }}
      >
        <div>
          <h3>Bem vindo ao Painel da Ibraflex</h3>
          <p>Preencha os campos abaixo para fazer login.</p>
          <form className="m-t" id="form-login">
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Usuário"
                value={state.email}
                onChange={(event) => preencherValoresEdits(event)}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="senha"
                className="form-control"
                placeholder="Senha"
                value={state.senha}
                onChange={(event) => preencherValoresEdits(event)}
              />
            </div>
            <button
              type="submit"
              className="btn btn-success block full-width m-b"
              onClick={(e) => enviarFormulario(e)}
            >
              Login
            </button>
          </form>
          <p className="m-t">
            {" "}
            <small>Ibraflex &copy; 2022</small>{" "}
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
